// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root___aMyI","left":"styles_left__3WAwh","desktopActions":"styles_desktopActions__e1nNH","title":"styles_title__6x4cG"};